import React from 'react'
import NavLink from '../Routes/NavLink.js';
import { browserHistory } from 'react-router'

import Timeline from './Timeline.jsx'
import TaskPrimitives from "./TaskPrimitives";
import { UpcomingTask } from "../../core/controllers/UpcomingTasks";

/**
 * Check if the time supplied has already expired
 * @param {*} time a string formatted as <hours>:<minutes>:<seconds>
 * @returns true if the thing is expired
 */
function checkExpired(time) {
    let [hour, minute, seconds] = time.split(':').map(parseInt);
    let date = new Date()
    time = date.getHours()*60 + date.getMinutes + date.getSeconds()/10
    return(time >= (hour*60 + minute + seconds/10));
}

export default class UpcomingTasks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taskChildren: [], /* Task children is the array for holding task
            components after supplied with their props, see the switch in 
            handleUpdatedTasks */
        }
    }

    updateTasks() { // Get all tasks from api
        UpcomingTask.getTasks(response => {
            this.handleUpdatedTasks(response)
        });
    }

    componentDidMount() {
        this.updateTasks()
    }


    /**
     * Applies the corresponding properties to records from /tasks/today
     * before sending to the timeline component for wrapping
     * @param {*} response The reponse from querying the /tasks/today route
     */
    handleUpdatedTasks(response) {
        let taskChildren = [];
        let taskActionTime;
        let i = 0;
        for (let record of response.data) {
            i++;
            taskActionTime = record.task_due_date
            let html = record.html ? (
                record.html
                    .replace(/\n/g, "")
                    .replace("/<a>/g", "<TaskHyperlink>")
                    .replace("/<\/a>/g", "</TaskHyperlink>")
            ) : (
                "<span>Error</span>"
            )
            switch (record.task_type) { /* Todo: remove TaskPrimitive.jsx and 
                                           move the default props here for 
                                           simplification */
                case "invoice_generate":
                    taskChildren.push(
                        <TaskPrimitives.InvoiceGenerate
                            taskActionTime={taskActionTime}
                            html={html}
                            runAction={
                                (resolve) => {
                                    return UpcomingTask.postTask(record, (response) => {
                                        resolve(response)
                                    })
                                }
                            }
                            key={`task-${i}`}
                        />
                    )
                    break;
                case "late_rent":
                    taskChildren.push(
                        <TaskPrimitives.LateRent
                            taskActionTime={taskActionTime}
                            html={html}
                            runAction={
                                (resolve) => {
                                    return UpcomingTask.postTask(record, (response) => {
                                        resolve(response)
                                    })
                                }
                            }
                            key={`task-${i}`}
                        />
                    )
                    break;
                case "lease_expire":
                    break;
                case "run_payouts":
                    taskChildren.push(
                        <TaskPrimitives.Payouts
                            taskActionTime={taskActionTime}
                            html={html}
                            runAction={() => {
                                //navigate to payouts
                                browserHistory.replace('/owners/payouts')
                                return true;
                            }}
                            key={`task-${i}`}
                        />
                    )
                    break;
                case "vendor_bill_due":
                    taskChildren.push(
                        <TaskPrimitives.Payables
                            taskActionTime={taskActionTime}
                            html={html}
                            runAction={() => {
                                browserHistory.replace(`/payables/bills/${record.meta_data.vendor_bill_id}`)
                                return true;
                            }}
                            key={`task-${i}`}
                        />
                    )
                    break;
                case "runReports":
                    taskChildren.push(
                        <TaskPrimitives.Reports
                            taskActionTime={taskActionTime}
                            html={html}
                            runAction={() => {
                                browserHistory.replace('/reports')
                                return true;
                            }}
                            key={`task-${i}`}
                        />
                    )
                    break;
            }
        }
        this.setState({
            taskChildren: taskChildren
        })
    }

    render() {
        const permissions = this.props.permissions
        return (
            <div className="upcoming-tasks">
                <div className="task-card card" >
                    <button type="button"
                        onClick={this.props.toggleVisible}
                        class="close"
                        data-dismiss="modal"
                        aria-label="Ok"
                        style={{ zIndex: "1", margin: 0, paddingLeft: "7px", position: "absolute" }}
                    >
                        <span style={{ color: "#0078FF", fontSize: "40px" }}>
                            ×
                        </span>
                    </button>
                        <div className="header" style={{}}>
                            <h4 className="title">
                                <span>Upcoming Tasks</span>
                            </h4>
                            <p className="category">Manage and address upcoming automated tasks</p>
                        </div>
                    <div className="timeline-holder">
                        {permissions ? (
                            this.state.taskChildren.length >= 1 ? (
                                <Timeline>
                                    {this.state.taskChildren}
                                </Timeline>
                            ) : (
                                <p>
                                    No upcoming tasks, check back later.
                                </p>
                            )
                        ) : (
                            <div class="upcoming-tasks-upgrade">
                                <p>Available with a Premium Subscription</p>
                                <div style={{marginTop: "10px"}}>
                                    <NavLink to={"/subscription"}>
                                        <button type="button" id="add-owner" data-loading-text="Loading..." class="btn btn-info btn-secondary btn-fill" autoComplete="off">
                                            Upgrade Plan
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/UpcomingTasks/UpcomingTasks.jsx